<template>
  <div class="container">
        <div class="bg">
            <p @click="toSign" style="padding:0 12px"><img src="@/assets/img/back2.png" alt=""></p>
            <ul v-if="flag == true">
                <li v-for="(item,index) in MyprizeList" :key="index">
                    <div class="leftcontent">
                        <p style="font-weight:700">{{item.prizeName}}</p>
                        <p class="gettime">获取时间:{{item.createTime}}</p>
                    </div>
                    <div class="rightcontent">
                        <button @click.prevent="exchange(item.id,item.prizeId)" v-if="item.status == 0">兑换</button>
                        <button @click.prevent="hadexchange" v-else>兑换成功</button>
                    </div>
                </li>
            </ul>
            <ul v-else>
                <li style="display:flex;align-items: center;justify-content: center;">还没有奖品哟~</li>
            </ul>
        <!-- <footer>
            底部固定菜单
        </footer> -->
        <!-- 弹出框 -->
        <van-dialog v-model="show" title="需要兑换的iccid号" show-cancel-button  @confirm="handleConfirm">
            <van-form ref="myform">
                <van-field
                    v-model="RequestData.iccid"
                    name="name"
                    placeholder="请输入ICCID号"
                    :rules="[
                        { required: true }
                    ]"
                />
            </van-form>
        </van-dialog>
      </div>
  </div>
</template>

<script>
import { wxRequest } from '@/api/user';
import { Dialog, Form, Field} from 'vant';
import { Toast }  from 'mint-ui';
export default {
    data() {
        return {
            MyprizeList: [],
            RequestData: {
                id : '',
                phone: '',
                recordId: null,
                iccid: null,
                // pageNo: 1,
                // perPageNum: 15
            },
            flag: false,
            show:false,
            exchangeId: null,  // 兑换奖品的id,

            loading: false,
            loadingMore: false,//loading 加载更多
            isScroll: true,//是否可以滚动
        }
    },
    methods: {
        toSign() {
            this.$router.push({
                path: '/appSignin',
                query: {
                    phone: localStorage.getItem('phone'),
                    id: localStorage.getItem('id')
                }
            })
        },
        // 获取我的奖品列表
        getMyprizeList() {
            wxRequest('xxtx/app/user/lottery/record',this.RequestData,'post').then(res => {
                if (res.data.code == '200') {
                    this.MyprizeList = this.MyprizeList.concat(res.data.data.resultList);
                    this.loadingMore = false
                    if (this.MyprizeList.length > 0) {
                        this.flag = true
                        this.isScroll = true
                    }
                }
            })
        },
        // 点击兑换
        exchange(id,prizeId) {
            this.RequestData.recordId = id
            if (prizeId >= 30 && prizeId <=39) {
                this.show = true
            } 
            else {
                // 直接发兑换请求，无需用户进行输入
                this.postResult();
            }
        },
        // 已兑换
        hadexchange() {
            Toast({
                message: '您已兑换该商品',
                position: 'top',
            });
        },
        // 提交兑换
        handleConfirm() {
          this.postResult()
        },
        // 请求兑换接口
        postResult() {
            wxRequest('xxtx/app/user/lottery/exchange ',this.RequestData,'post').then(res => {
                if(res.data.code == '200') {
                    Toast(res.data.message);
                    this.getMyprizeList();
                }
                else {
                    Toast(res.data.message);
                }
                
            })
        },
        scrollMoreData() {
            const scrollTopHeight = document.documentElement.scrollTop || document.body.scrollTop //滚动高度

            const clientHeight = document.documentElement.clientHeight || window.screen.availHeight //屏幕可用工作区高度

            const offsetHeight = document.documentElement.offsetHeight || document.body.offsetHeight //网页可见区域高(包括边线的宽)

            if ((scrollTopHeight + clientHeight) + 50 >= offsetHeight && this.isScroll) {
                this.isScroll = false
                this.loadingMore = true
                this.RequestData.pageNo = this.RequestData.pageNo += 1
            }
        }
    },
    created() {
        this.RequestData.id = this.$route.query.id;
        this.RequestData.phone = this.$route.query.phone;
        this.getMyprizeList();
    },
    mounted() {
        document.addEventListener('scroll', this.scrollMoreData, false)
    },
    destroyed() {
        document.removeEventListener('scroll', this.scrollMoreData, false)
    }
}
</script>

<style lang="less">
.container {
    width: 100%;
    .bg {
    /* width: 100%; */
    width: 100%;
    // background: linear-gradient(top,#f2d089,#f56586);

    ul {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding-bottom: 0.625rem;
        color: #434343;
        li {
            display: flex;
            width: 100%;
            height: 4.75rem;
            // margin: 0 0.9375rem;
            // margin-top: 0.625rem;
            // border: solid 1px #ffffff;
            // border-radius: 0.3125rem;
            padding: 0 0.9375rem;
            font-size: 16px;
            border-bottom: 0.5px solid #dbdbdb;
            // color: #ffffff;
            // background: linear-gradient(to right, #90dffe 0%, #38a3d1 100%);
            .leftcontent {
                width: 75%;
                float: left;
                display: flex;
                flex-direction: column;
                align-items: left;
                justify-content: center;
                padding-left: 1.625rem;
                .gettime {
                    padding-top: 0.5rem;
                    font-size: 14px;
                    color: #969696;
                }
            }
            .rightcontent {
                width: 25%;
                display: flex;
                flex-direction: column;
                align-items: right;
                justify-content: center;
                padding-right: 0.5rem;
                color: #5e9bff;
                button {
                    border: 1px solid #fff;
                    padding: 0.25rem 0.5rem;
                    border-radius: 0.25rem;
                    background-color: transparent;
                    outline: none;    //消除默认点击蓝色边框效果
                }
            }
        }
    }
    }
    footer {
        position:fixed;bottom:0;z-index:999;
        background:#fff;max-width: 750px;width: 100%;height: 3.75rem;
    }

}

</style>>
